(() => {
  const colorOptionNames = new Set([
    'color',
    'colour',
    'leather color',
    'leather colour',
  ]);
function getHulkSelects(scope) {
  return Array.from(scope.querySelectorAll('select')).filter((sel) => {
    const id = (sel.getAttribute('id') || '').trim();
    const name = (sel.getAttribute('name') || '').trim();
    // 헐크 앱은 숫자 ID를 사용함
    return /^\d+$/.test(id) || /^\d+$/.test(name);
  });
}


function hulkSelectsComplete(state) {
  const hulkSelects = getHulkSelects(state.scope);
  if (!hulkSelects.length) return true;
  return hulkSelects.every((sel) => String(sel.value || '').trim() !== '');
}
  const sizeOptionNames = new Set([
    'size',
    'bible size',
    'bible size category',
    'bible size category (longest side)',
    'size (the longest side)',
  ]);

  const selectLabelText = 'Please select';
  const states = new Map();

  const normalize = (value = '') =>
    value.trim().toLowerCase().replace(/\s+/g, ' ');

  function addRequiredSelectionStyles() {
    if (document.getElementById('lor-required-variant-styles')) return;

    const style = document.createElement('style');
    style.id = 'lor-required-variant-styles';
    style.textContent = `
      variant-picker
      .variant-option__button-label:not(:has(input:checked))
      .variant-option__button-label__pill {
        background: transparent !important;
        background-color: transparent !important;
        opacity: 0 !important;
      }
    `;

    document.head.appendChild(style);
  }

  function getOptionName(control) {
    if (control.matches('select')) {
      const namedOption = Array.from(control.options).find(
        (option) => option.dataset.optionName
      );

      return (
        namedOption?.dataset.optionName ||
        control.dataset.optionName ||
        control.name ||
        ''
      );
    }

    return control.dataset.optionName || control.name || '';
  }

  function getOptionGroup(control) {
    const name = normalize(getOptionName(control));

    if (
      colorOptionNames.has(name) ||
      name.includes('leather color') ||
      name.includes('leather colour')
    ) {
      return 'color';
    }

    if (
      sizeOptionNames.has(name) ||
      name.includes('size category') ||
      name.includes('longest side')
    ) {
      return 'size';
    }

    return null;
  }

  function getGroupControls(picker, group) {
    return Array.from(
      picker.querySelectorAll(
        'input[type="radio"][data-option-name], select.variant-option__select'
      )
    ).filter((control) => getOptionGroup(control) === group);
  }

  function getChoiceCount(picker, group) {
    const controls = getGroupControls(picker, group);
    const radios = controls.filter((control) =>
      control.matches('input[type="radio"]')
    );

    if (radios.length) return radios.length;

    const select = controls.find((control) => control.matches('select'));

    if (!select) return 0;

    return Array.from(select.options).filter(
      (option) =>
        option.value !== '' &&
        option.dataset.lorPlaceholder !== 'true'
    ).length;
  }

  function getRequiredGroups(picker) {
    return ['size', 'color'].filter(
      (group) => getChoiceCount(picker, group) > 1
    );
  }

  function getScope(picker) {
    return (
      picker.closest('.shopify-section, dialog, product-card') ||
      document
    );
  }

  function findProductForm(state) {
    const selector =
      `product-form-component[data-product-id="${state.productId}"]`;

    return (
      state.scope.querySelector(selector) ||
      document.querySelector(selector)
    );
  }

  function getVariantIdInput(state) {
    state.productForm = findProductForm(state);

    return state.productForm?.querySelector(
      'input[name="id"][ref="variantId"], input[name="id"]'
    );
  }

  function getAddToCartButtons(state) {
    state.productForm = findProductForm(state);

    if (!state.productForm) return [];

    return Array.from(
      state.productForm.querySelectorAll(
        '[ref="addToCartButton"], button[type="submit"][name="add"]'
      )
    );
  }

  function setButtonText(button, text) {
    if (!button || button.dataset.lorButtonText === text) return;

    const horizonText = button.querySelector(
      '.add-to-cart-text__content > span:first-child'
    );

    if (horizonText) {
      horizonText.textContent = text;
    } else {
      const directTextNode = Array.from(button.childNodes).find(
        (node) =>
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.trim() !== ''
      );

      if (directTextNode) {
        directTextNode.textContent = ` ${text} `;
      }
    }

    button.dataset.lorButtonText = text;
    button.setAttribute('aria-label', text);
  }

  function getLockMessage(missingGroups) {
    const needsSize = missingGroups.includes('size');
    const needsColor = missingGroups.includes('color');

    if (needsSize && needsColor) return 'Select size and color';
    if (needsSize) return 'Select a size';
    if (needsColor) return 'Select a color';

    return 'Complete required options';
  }

  function updatePrompt(state, group, missing) {
    const controls = getGroupControls(state.picker, group);

    const fieldsets = Array.from(
      new Set(
        controls
          .map((control) => control.closest('fieldset'))
          .filter(Boolean)
      )
    );

    fieldsets.forEach((fieldset) => {
      const valueLabel = fieldset.querySelector(
        '.variant-option__swatch-value'
      );

      const existingPrompt = fieldset.querySelector(
        '[data-lor-selection-prompt]'
      );

      if (missing) {
        if (valueLabel) {
          valueLabel.textContent = selectLabelText;
          valueLabel.dataset.lorSelectionPrompt = 'true';
        } else if (!existingPrompt) {
          const legend = fieldset.querySelector('legend');

          if (legend) {
            const prompt = document.createElement('span');
            prompt.dataset.lorSelectionPrompt = 'true';
            prompt.textContent = ` — ${selectLabelText}`;
            legend.appendChild(prompt);
          }
        }
      } else {
        existingPrompt?.remove();

        if (
          valueLabel?.dataset.lorSelectionPrompt === 'true' &&
          valueLabel.textContent.trim() === selectLabelText
        ) {
          valueLabel.textContent = '';
          delete valueLabel.dataset.lorSelectionPrompt;
        }
      }
    });
  }

  function clearGroup(state, group) {
    const controls = getGroupControls(state.picker, group);

    controls.forEach((control) => {
      if (control.matches('input[type="radio"]')) {
        control.checked = false;
        control.removeAttribute('checked');
        control.setAttribute('aria-checked', 'false');
        return;
      }

      if (control.matches('select')) {
        let placeholder = control.querySelector(
          'option[data-lor-placeholder="true"]'
        );

        if (!placeholder) {
          placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'Please select';
          placeholder.disabled = true;
          placeholder.dataset.lorPlaceholder = 'true';
          control.prepend(placeholder);
        }

        placeholder.selected = true;
        control.value = '';
      }
    });

    updatePrompt(state, group, true);
  }

  function hasIncompleteCustomFields(state) {
    const fields = Array.from(
      state.scope.querySelectorAll(
        'input[required], select[required], textarea[required], [aria-required="true"]'
      )
    );

    return fields.some((field) => {
      if (
        field.disabled ||
        field.closest('variant-picker') ||
        field.type === 'hidden' ||
        field.getClientRects().length === 0
      ) {
        return false;
      }

      if (field.type === 'radio') {
        if (!field.name) return !field.checked;

        const group = Array.from(
          state.scope.querySelectorAll(
            `input[type="radio"][name="${CSS.escape(field.name)}"]`
          )
        );

        return !group.some((radio) => radio.checked);
      }

      if (field.type === 'checkbox') {
        return !field.checked;
      }

      if (field.type === 'file') {
        return !field.files || field.files.length === 0;
      }

      return !String(field.value || '').trim();
    });
  }

  function lockProductForm(
    state,
    text,
    clearVariantId = true
  ) {
    if (state.variantWaitTimer) {
      clearTimeout(state.variantWaitTimer);
      state.variantWaitTimer = null;
    }

    const variantId = getVariantIdInput(state);

    if (variantId && clearVariantId) {
      variantId.value = '';
      variantId.setAttribute('value', '');
    }

    getAddToCartButtons(state).forEach((button) => {
      button.dataset.lorRequiredLock = 'true';
      button.disabled = true;
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      setButtonText(button, text);
    });

    state.productForm
      ?.querySelectorAll(
        '[ref="acceleratedCheckoutButtonContainer"]'
      )
      .forEach((container) => {
        container.hidden = true;
      });

    const stickyCart = document.querySelector(
      `sticky-add-to-cart[data-product-id="${state.productId}"]`
    );

    if (stickyCart) {
      stickyCart.dataset.variantAvailable = 'false';

      const stickyButton = stickyCart.querySelector(
        '[ref="addToCartButton"]'
      );

      if (stickyButton) {
        stickyButton.dataset.lorRequiredLock = 'true';
        stickyButton.disabled = true;
        stickyButton.setAttribute('disabled', 'disabled');
        stickyButton.setAttribute('aria-disabled', 'true');
        setButtonText(stickyButton, text);
      }
    }
  }

  function selectedCombinationUnavailable(state) {
    const selectedControls = state.requiredGroups.flatMap(
      (group) =>
        getGroupControls(state.picker, group).filter(
          (control) =>
            control.matches('input[type="radio"]') &&
            control.checked
        )
    );

    return selectedControls.some(
      (control) =>
        normalize(control.dataset.optionAvailable) === 'false'
    );
  }

  function unlockProductForm(state) {
    const variantId = getVariantIdInput(state);

    if (
      !variantId?.value ||
      selectedCombinationUnavailable(state)
    ) {
      return false;
    }

    getAddToCartButtons(state).forEach((button) => {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      delete button.dataset.lorRequiredLock;
      setButtonText(button, 'Add to cart');
    });

    const stickyCart = document.querySelector(
      `sticky-add-to-cart[data-product-id="${state.productId}"]`
    );

    if (stickyCart) {
      stickyCart.dataset.variantAvailable = 'true';
      stickyCart.dataset.currentVariantId = variantId.value;

      const stickyButton = stickyCart.querySelector(
        '[ref="addToCartButton"]'
      );

      if (stickyButton) {
        stickyButton.disabled = false;
        stickyButton.removeAttribute('disabled');
        stickyButton.removeAttribute('aria-disabled');
        delete stickyButton.dataset.lorRequiredLock;
        setButtonText(stickyButton, 'Add to cart');
      }
    }

    return true;
  }

  function waitForValidVariant(state, attempt = 0) {
    if (unlockProductForm(state)) {
      state.variantWaitTimer = null;
      return;
    }

    if (attempt >= 30) {
      state.variantWaitTimer = null;
      lockProductForm(
        state,
        'Select an available combination',
        false
      );
      return;
    }

    state.variantWaitTimer = setTimeout(() => {
      waitForValidVariant(state, attempt + 1);
    }, 100);
  }

  function enforceState(state) {
    state.picker =
      state.scope.querySelector(
        `variant-picker[ref="mainVariantPicker"][data-product-id="${state.productId}"]`
      ) || state.picker;

    state.requiredGroups = getRequiredGroups(state.picker);

    const missingGroups = state.requiredGroups.filter(
      (group) => !state.selectedGroups.has(group)
    );

    state.requiredGroups.forEach((group) => {
      const missing = missingGroups.includes(group);

      if (missing) {
        clearGroup(state, group);
      } else {
        updatePrompt(state, group, false);
      }
    });

    if (missingGroups.length) {
      lockProductForm(
        state,
        getLockMessage(missingGroups),
        true
      );
      return;
    }

    if (hasIncompleteCustomFields(state) || !hulkSelectsComplete(state)) {
      lockProductForm(
        state,
        'Complete required options',
        false
      );
      return;
    }

    if (!state.variantWaitTimer) {
      waitForValidVariant(state);
    }
  }

  function scheduleEnforcement(state) {
    if (state.scheduled) return;

    state.scheduled = true;

    requestAnimationFrame(() => {
      state.scheduled = false;
      enforceState(state);
    });
  }

  function initializePicker(picker) {
    const productId = picker.dataset.productId;

    if (!productId) return;

    const scope = getScope(picker);
    const sectionKey = scope.id || 'main';
    const stateKey = `${sectionKey}-${productId}`;

    let state = states.get(stateKey);

    if (!state) {
      state = {
        productId,
        picker,
        scope,
        productForm: null,
        requiredGroups: [],
        selectedGroups: new Set(),
        scheduled: false,
        variantWaitTimer: null,
        observer: null,
      };

      states.set(stateKey, state);

      state.observer = new MutationObserver(() => {
        scheduleEnforcement(state);
      });

      state.observer.observe(scope, {
        childList: true,
        subtree: true,
      });
    } else {
      state.picker = picker;
      state.scope = scope;
    }

    state.requiredGroups = getRequiredGroups(picker);

    if (!state.requiredGroups.length) return;

    scheduleEnforcement(state);
  }

  function initializeAll(root = document) {
    root
      .querySelectorAll(
        'variant-picker[ref="mainVariantPicker"]'
      )
      .forEach(initializePicker);
  }

  function getStateForPicker(picker) {
    const productId = picker.dataset.productId;
    const scope = getScope(picker);
    const sectionKey = scope.id || 'main';

    return states.get(`${sectionKey}-${productId}`);
  }

  function handleOptionSelection(event) {
    const control = event.target.closest(
      'input[type="radio"][data-option-name], select.variant-option__select'
    );

    if (!control) return;

    const picker = control.closest(
      'variant-picker[ref="mainVariantPicker"]'
    );

    if (!picker) return;

    initializePicker(picker);

    const state = getStateForPicker(picker);
    const group = getOptionGroup(control);

    if (
      !state ||
      !group ||
      !state.requiredGroups.includes(group)
    ) {
      return;
    }

    if (
      control.matches('input[type="radio"]') &&
      control.checked
    ) {
      state.selectedGroups.add(group);
    }

    if (
      control.matches('select') &&
      String(control.value || '').trim()
    ) {
      state.selectedGroups.add(group);
    }

    updatePrompt(state, group, false);
    scheduleEnforcement(state);

    [100, 300, 700, 1200].forEach((delay) => {
      setTimeout(() => scheduleEnforcement(state), delay);
    });
  }

  function handleCustomFieldInput(event) {
    const scope = event.target.closest('.shopify-section');

    if (!scope) return;

    states.forEach((state) => {
      if (state.scope === scope) {
        scheduleEnforcement(state);
      }
    });
  }

  function protectProductSubmission(event) {
    const productFormComponent = event.target.closest(
      'product-form-component'
    );

    if (!productFormComponent) return;

    const productId =
      productFormComponent.dataset.productId;

    const state = Array.from(states.values()).find(
      (candidate) =>
        candidate.productId === productId &&
        candidate.scope.contains(productFormComponent)
    );

    if (!state) return;

    const missingGroups = state.requiredGroups.filter(
      (group) => !state.selectedGroups.has(group)
    );

    const variantId = getVariantIdInput(state);

    if (
      missingGroups.length ||
      hasIncompleteCustomFields(state) ||
      !variantId?.value
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      enforceState(state);
      state.picker.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }

  addRequiredSelectionStyles();

  document.addEventListener(
    'change',
    handleOptionSelection,
    true
  );

  document.addEventListener(
    'input',
    handleCustomFieldInput,
    true
  );

  document.addEventListener(
    'submit',
    protectProductSubmission,
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAll();
    });
  } else {
    initializeAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeAll(event.target);
    }
  );

  const pageObserver = new MutationObserver((mutations) => {
    const pickerAdded = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (
            node.matches?.(
              'variant-picker[ref="mainVariantPicker"]'
            ) ||
            node.querySelector?.(
              'variant-picker[ref="mainVariantPicker"]'
            )
          )
      )
    );

    if (pickerAdded) initializeAll();
  });

  pageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();